<template>
  <li class="text-xs">
    <strong v-text="label" /> {{ value ? value : 'n/a' }}
  </li>
</template>

<script type="text/babel">
export default {
  name: 'AccessRequestCustomField',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      required: true,
      validator: prop => typeof prop === 'string' || prop === null,
    },
  },
}
</script>
